import { render, staticRenderFns } from "./multipleChoiceSharingMenuRow.vue?vue&type=template&id=13650a9e&scoped=true"
import script from "./multipleChoiceSharingMenuRow.vue?vue&type=script&lang=js"
export * from "./multipleChoiceSharingMenuRow.vue?vue&type=script&lang=js"
import style0 from "./multipleChoiceSharingMenuRow.vue?vue&type=style&index=0&id=13650a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13650a9e",
  null
  
)

export default component.exports